import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=d00ffc9c"
import script from "./Puzzle.vue?vue&type=script&lang=ts"
export * from "./Puzzle.vue?vue&type=script&lang=ts"
import style0 from "./Puzzle.vue?vue&type=style&index=0&id=d00ffc9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports